import { CLEAR_ERRORS, HAS_ERRORS } from "./actionTypes";

export const clearErrors = () => ({
  type: CLEAR_ERRORS
})

export const hasError = () => ({
  type: HAS_ERRORS
})